import { render, staticRenderFns } from "./chapterRecord.vue?vue&type=template&id=7ae6913a&"
import script from "./chapterRecord.vue?vue&type=script&lang=js&"
export * from "./chapterRecord.vue?vue&type=script&lang=js&"
import style0 from "./chapterRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports